import { render, staticRenderFns } from "./ModuleControlIndex.vue?vue&type=template&id=5c771800&scoped=true"
import script from "./ModuleControlIndex.vue?vue&type=script&lang=js"
export * from "./ModuleControlIndex.vue?vue&type=script&lang=js"
import style0 from "./ModuleControlIndex.vue?vue&type=style&index=0&id=5c771800&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c771800",
  null
  
)

export default component.exports